<template lang="pug">
  #appRoot
    v-dialog(persistent, v-model="$root.dialog.printer", max-width="600", v-if="$root.dialog.printer && $root.printers.length")
      v-card
        v-card-title.headline.fontPerson Selecionar Impressoras
        v-card-text
          v-layout(row, wrap)
            v-flex.xs12
              .subheading.font-weight-medium Impressoras
              .impressora(v-for="(printer, index) in $root.printers", :key="index", @click="!isSelected(printer) && visibleSelectedCount >= 2 ? emitirErro() : null")
                v-checkbox(color="primary", :input-value="isSelected(printer)", @change="togglePrinter(printer)", :label="printer", :hide-details="true", :disabled="!isSelected(printer) && visibleSelectedCount >= 2")
                template(v-if="isSelected(printer)")
                  v-layout.pl-4.pt-1.pb-2(row, wrap)
                    v-flex.xs6
                      .caption.font-weight-medium Tamanho
                      v-radio-group.mt-1(v-model="getSelectedPrinter(printer).tamanho", :mandatory="true", :hide-details="true")
                        v-radio(color="primary", label="Pequena", :value="1")
                        v-radio(color="primary", label="Grande", :value="2")
                    v-flex.xs6
                      .caption.font-weight-medium Layout
                      .layout-options-col.mt-1
                        template(v-for="opt in $root.optionsLayout")
                          .layout-option-row(:key="opt.id")
                            .layout-option(@click="getSelectedPrinter(printer).layout = opt.id")
                              v-icon(:color="getSelectedPrinter(printer).layout === opt.id ? 'primary' : ''") {{ getSelectedPrinter(printer).layout === opt.id ? 'radio_button_checked' : 'radio_button_unchecked' }}
                              span.ml-2.gray--text {{ opt.nome }}
                            v-menu(open-on-hover, :close-on-content-click="false", left, offset-x, max-width="240", :nudge-top="40", content-class="layout-preview-menu")
                              v-btn(icon, slot="activator", small)
                                v-icon(color="grey darken-1", small) visibility
                              v-card
                                print-layout-preview(:layout="opt.id")
        v-card-actions
          v-spacer
          v-btn(flat, type="button", @click="$root.dialog.printer = false;") Fechar
          v-btn(color="primary", type="button", @click="savePrinters").white--text Salvar

    v-dialog(v-model="$root.dialog.termoAdesao", max-width="600", :persistent="$root.termoAdesao && $root.user && $root.termoAdesao.versao > $root.user.termo_adesao", scrollable, v-if="$root.dialog.termoAdesao && $root.termoAdesao")
      v-card
        v-card-title
          span.title {{ $root.termoAdesao.titulo }}
          v-spacer
          v-tooltip(top, v-if="!($root.termoAdesao && $root.user && $root.termoAdesao.versao > $root.user.termo_adesao)")
            v-btn(icon, slot="activator", @click.native="$root.dialog.termoAdesao = false;")
              v-icon close
            span Fechar
        v-card-text(v-html="$root.termoAdesao.texto")
        v-card-actions(v-if="$root.termoAdesao && $root.user && $root.termoAdesao.versao > $root.user.termo_adesao")
          v-spacer
          v-btn(color="accent", type="button", @click="$root.aceitarTermoAdesao").white--text Aceitar

    template(v-if='!$route.meta.public')
      v-app#inspire.app
        environment-banner
        app-drawer.app--drawer
        app-toolbar.app--toolbar
        v-content.areaContent
          .page-wrapper
            router-view
          // App Footer
          v-footer.white.app--footer(height='auto')
            v-btn(flat, href="https://api.whatsapp.com/send?phone=5532988929726", target="_blank", @click="contatarSuporte('rodape')")
              span.caption Suporte:
              span.caption.font-weight-bold.ml-1 (32) 98892-9726
            v-spacer.hidden-sm-and-down
            v-btn(flat, href="http://labcinco.com", target="_blank").hidden-sm-and-down
              span.caption.mr-1 © 2017-{{ new Date().getFullYear() }} - Desenvolvido por
              span.caption.font-weight-bold.black--text Lab Cinco
        // Botões flutuantes: voltar ao topo + suporte
        .app-fabs
          app-fab
          suporte-fab
    template(v-else)
      transition
        keep-alive
          router-view
    v-snackbar.ui-snackbar(:timeout='3000', top, right, :color='snackbar.color', v-model='snackbar.show')
      | {{ snackbar.text }}
      v-btn(dark, flat, @click.native='snackbar.show = false', icon)
        v-icon close
</template>

<script>
import _ from 'lodash';
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import SuporteFab from '@/components/SuporteFab';
import AppEvents from  './event';
import PrintLayoutPreview from '@/components/PrintLayoutPreview';
import EnvironmentBanner from '@/components/EnvironmentBanner';
import { registrarContatoSuporte } from '@/util/suporte';

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    SuporteFab,
    PrintLayoutPreview,
    EnvironmentBanner,
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    dialog: {
      aux: false,
    },
    snackbar: {
      show: false,
      text: '',
      color: '',
    },
    printer: {},
    selectedPrinters: [],
  }),
  computed: {
    visibleSelectedCount() {
      return this.selectedPrinters.filter(p => this.$root.printers.includes(p.nome)).length;
    },
  },
  watch: {
    '$root.dialog.printer' (val) {
      if (val) {
        const printerData = this.$root.printer;
        this.selectedPrinters = Array.isArray(printerData) ? _.cloneDeep(printerData) : printerData ? [_.cloneDeep(printerData)] : [];
      }
    },
    $route (route) {
      const pathLogin = "/login";
      if (route.meta.public && this.$root.user) {
        window.getApp.$emit('APP_LOGIN_SUCCESS');
      } else if (!this.$root.user && route.path != pathLogin) {
        window.sessionStorage.setItem('redirectAfterLogin', route.fullPath);
        this.$router.push({ path: pathLogin });
      }
      if (route.name == 'Pedidos') {
        document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      } else {
        document.getElementsByTagName('html')[0].style.overflowY = 'scroll';
      }
    },
  },

  created () {
    const vm = this;
    AppEvents.forEach(item => {
      vm.$on(item.name, item.callback);
    });
    window.getApp = vm;

    if (vm.$route.name == 'Pedidos') {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
    }
  },
  mounted() {
    const printerData = this.$root.printer;
    this.selectedPrinters = Array.isArray(printerData) ? printerData : printerData ? [printerData] : [];
  },
  methods: {
    contatarSuporte(origem) {
      registrarContatoSuporte(origem, this.$root.estabelecimentoSelecionado);
    },
    isSelected(printer) {
      return this.selectedPrinters.some(function(p) {
        return p.nome == printer;
      });
    },
    togglePrinter(printer) {
      if (!printer) return;

      var index = this.selectedPrinters.findIndex(function(p) {
        return p.nome == printer;
      });

      if (index == -1) {
        // conta apenas as impressoras visíveis no dialog (disponíveis no QZ Tray)
        const visibleSelected = this.selectedPrinters.filter(p => this.$root.printers.includes(p.nome));
        if (visibleSelected.length < 2) {
          this.selectedPrinters.push({
            nome: printer,
            tamanho: 1,
            layout: 1,
          });
        } else {
          window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Você só pode selecionar no máximo duas impressoras!' });
        }
      } else {
        this.selectedPrinters.splice(index, 1);
      }
    },
    savePrinters() {
      const validSelected = this.selectedPrinters.filter(p => this.$root.printers.includes(p.nome));

      if (validSelected.length == 0) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Selecione pelo menos uma impressora.' });
        return;
      }

      this.$root.selectPrinter(validSelected);
      this.$root.dialog.printer = false;
    },
    getSelectedPrinter(printer) {
      return this.selectedPrinters.find(p => p.nome === printer);
    },
    emitirErro(){
      window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Você só pode selecionar no máximo duas impressoras!' });
    }
  }
};
</script>

<style lang="scss">
#nprogress .spinner-icon {
  border-top-color: black!important;
  border-left-color: black!important;
}
#nprogress .bar {
  background: black!important;
}
.ui-snackbar{
  font-family: 'Poppins', 'Roboto', sans-serif !important;
  font-weight: 500;
  .v-snack__wrapper{
    border-radius: 8px!important;
    padding: 10px 0px!important;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px!important;
  }
}
.fontPerson{
  font-family: 'Poppins', 'Roboto', sans-serif !important;
}
.impressora{
  padding: 5px 0px!important;
}
.layout-options-col {
  display: flex;
  flex-direction: column;
}
.layout-option-row {
  display: flex;
  align-items: center;
  .layout-option {
    flex: 1;
  }
}
.layout-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 0;
  user-select: none;
  font-size: 16px;
  &:hover span {
    color: #1976d2;
  }
}
.layout-preview-menu .v-card {
  max-height: 380px;
  overflow-y: auto;
}

.page-wrapper {
  padding-top: var(--env-banner-height, 0px);
}

.page-wrapper .application--wrap{
  min-height: calc(100vh - 112px - var(--env-banner-height, 0px))!important;
}

.v-snack__content {
  height: 60px!important;
}

.app--toolbar {
  z-index: 3!important;
}

.app-fabs {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

// O banner do onboarding (OnboardingFab) ocupa o canto inferior direito
body.has-onboarding-fab .app-fabs {
  display: none;
}
</style>
